module.exports = __webpack_public_path__ + "img/slide1-768.a3f4191b.png";